import { Button } from "@cliently/ui";
import type { MetricsRange } from "../lib/numeric-metrics-chart";

export interface NumericMetricsRangeSelectorProps {
  availableRanges: MetricsRange[];
  range: MetricsRange;
  onRangeChange: (range: MetricsRange) => void;
  rangeLabelByValue: Record<MetricsRange, string>;
  groupLabel: string;
}

/**
 * Boutons de sélection de période pour les graphiques de métriques numériques.
 * Composant pur (state vit chez le parent) afin d'être testable en isolation.
 */
export const NumericMetricsRangeSelector = ({
  availableRanges,
  range,
  onRangeChange,
  rangeLabelByValue,
  groupLabel,
}: NumericMetricsRangeSelectorProps) => {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      <span className="text-muted-foreground text-xs">{groupLabel}</span>
      <div
        data-testid="metrics-range-selector"
        className="bg-muted/40 inline-flex items-center gap-1 rounded-md border p-1"
      >
        {availableRanges.map((option) => {
          const selected = range === option;
          return (
            <Button
              key={option}
              type="button"
              variant={selected ? "default" : "ghost"}
              size="sm"
              className="h-7 px-2 text-xs"
              aria-pressed={selected}
              onClick={() => onRangeChange(option)}
            >
              {rangeLabelByValue[option]}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
